import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import defaultImg from '../../../assets/image/newShop/defaultImg.png';
import {ISubBrandAdvertisementsResult} from '../../../services/hookService/getSubBrandAdvertisementsList/types';
import {AdjectivalUnitTitle} from '../../../utilities/helper/unitGenerator/unit.types';
import BasketItemEditButton from '../../shopping-basket/components/BasketItemEditButton';
import RemoveFromBasketModal from '../../shopping-basket/ItemCard/RemoveFromBasketModal';
import {SaleMethodChoices} from './helper';

const AdvertisementCard = ({item}: {item: ISubBrandAdvertisementsResult}) => {
  const {
    id,
    title,
    store,
    state,
    city,
    main_image,
    min_sell_quantity,
    score,
    ad_price,
    quantity_pack,
    quantity_pack_unit,
    basket_quantity,
    basket_guid,
    hold_quantity,
    available_quantity,
  } = item;
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {inputGroupName} = useParams();

  const isLendTech =
    SaleMethodChoices(store?.sale_method)?.isDirectAndInstallment ||
    SaleMethodChoices(store?.sale_method)?.isDirect;

  return (
    <div
      className="flex relative z-20 flex-col gap-2 px-3 pt-3 pb-8 w-full bg-white rounded-xl border shadow-sm"
      onClick={() => navigate(`/category-card-detail/${inputGroupName}/${id}`)}
    >
      {/* Top Row */}
      <div className="flex relative justify-between items-start">
        {/* Image */}
        <img
          src={main_image || defaultImg}
          alt={title}
          className="object-cover rounded-lg size-14"
        />
        {/*Shop Badge */}
        {score && (
          <div className="flex absolute top-0 left-0 gap-2 justify-center items-center px-2 py-1 text-sm bg-gray-100 rounded-full">
            <i className="text-yellow-400 icon-nameStar" />
            <span>{score}</span>
          </div>
        )}
        {/*Personal Badge */}
        {!store?.guid && (
          <div className="flex absolute top-0 left-0 gap-2 justify-center items-center px-2 py-1 text-sm bg-gray-100 rounded-full">
            <span className="text-gray-600">آگهی شخصی</span>
          </div>
        )}
        {/* Text Section */}
        <div className="flex flex-col flex-1 gap-2 justify-center p-2 mt-2">
          {/* Title */}
          <h3 className="mb-0 text-sm font-medium text-gray-900">{title}</h3>

          {/* Price */}
          <div className="flex gap-2 font-normal text-gray-900 text-md">
            <span>{ad_price.toLocaleString()} تومان</span>
            {quantity_pack_unit && quantity_pack && (
              <span className="text-gray-600">
                (
                {'بسته ' +
                  quantity_pack +
                  ' ' +
                  AdjectivalUnitTitle[quantity_pack_unit]}
                )
              </span>
            )}
          </div>

          {/* Store + Location */}
          {(store || state || city) && (
            <div className="flex gap-1 text-sm text-gray-700">
              <div className="flex gap-1">
                {store?.title && <span>{store.title}</span>}
                {store?.title && <span> | </span>}

                <div className="text-gray-500">
                  {state && <span>{state}</span>}
                  {city && <span>- {city}</span>}
                </div>
              </div>
            </div>
          )}

          {/* Min quantity : show it when the ad is not personal */}
          {min_sell_quantity && store?.guid && (
            <div className="text-sm font-medium text-gray-700">
              حداقل خرید {min_sell_quantity} عدد
            </div>
          )}
        </div>

        {/* Bottom Action */}
        <div
          className="absolute left-0 -bottom-4 z-0"
          onClick={e => e.stopPropagation()}
        >
          {isLendTech ? (
            <>
              <BasketItemEditButton
                variant="md"
                hideToast
                min_sell_quantity={min_sell_quantity}
                available_quantity={available_quantity}
                hold_quantity={hold_quantity}
                basket_quantity={basket_quantity ?? 0}
                basket_guid={basket_guid ?? null}
                price={ad_price}
                advertisement_id={id}
                shouldRemoveItem={true}
                handleRemovingItem={setIsModalOpen}
              />
              <RemoveFromBasketModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                basket_guid={basket_guid}
              />
            </>
          ) : (
            <button
              onClick={e => {
                e.stopPropagation();
                navigate(`/category-card-detail/${inputGroupName}/${id}`);
              }}
              className="bg-[#518A15] text-white py-2 px-2 text-sm rounded-lg"
            >
              مشاهده آگهی
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdvertisementCard;
